import type { THttpMethod } from '@lib/types/THttpRequest';

export type THttpErrorMetadata = Readonly<{
  correlationId: string;
  endpoint: string;
  statusCode: number;
  statusMessage: string;
  method: THttpMethod;
}>;

export class HttpErrorResponse extends Error {
  response: Response;

  constructor(
    response: Response,
    private errorMetadata: THttpErrorMetadata,
  ) {
    super(errorMetadata.statusMessage);
    this.response = response;
  }

  public getHttpErrorMetadata(): THttpErrorMetadata {
    return this.errorMetadata;
  }
}

export function isHttpErrorResponse(error: unknown): error is HttpErrorResponse {
  return error instanceof HttpErrorResponse;
}
